import { render } from "./WelcomeHeader.vue?vue&type=template&id=0c3304ea&scoped=true"
import script from "./WelcomeHeader.vue?vue&type=script&lang=js"
export * from "./WelcomeHeader.vue?vue&type=script&lang=js"

import "./WelcomeHeader.vue?vue&type=style&index=0&id=0c3304ea&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3304ea"]])

export default __exports__